import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { StatCard } from '@/components/dashboard/StatCard';
import { RenewalWidget } from '@/components/dashboard/RenewalWidget';
import { useDashboardStats } from '@/hooks/useDashboardStats';
import type { TDashboardTimeRange } from '@/@types/aiReply';

export function DashboardPage() {
  const {
    stats,
    statsTimeRange,
    setStatsTimeRange,
    renewalPolicies,
    renewalTimeRange,
    setRenewalTimeRange,
    isStatsLoading,
  } = useDashboardStats();

  const aiVsHumanSubtitle =
    !isStatsLoading && stats
      ? `${stats.answeredByAi} AI · ${stats.answeredByHuman} human`
      : undefined;

  return (
    <div className="flex flex-col gap-6 p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-foreground">Dashboard</h1>
        <Select
          value={statsTimeRange}
          onValueChange={v => setStatsTimeRange(v as TDashboardTimeRange)}
        >
          <SelectTrigger className="w-28 h-8 text-sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="24h">24 hours</SelectItem>
            <SelectItem value="7d">7 days</SelectItem>
            <SelectItem value="30d">30 days</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatCard
          label="Unanswered Messages"
          value={stats?.unansweredCount}
          subtitle="Pending AI drafts"
        />
        <StatCard
          label="Answered Messages"
          value={stats?.answeredCount}
          subtitle="Sent in selected period"
        />
        <StatCard
          label="AI vs Human Replies"
          value={stats?.answeredCount}
          subtitle={aiVsHumanSubtitle}
        />
      </div>

      <RenewalWidget
        policies={renewalPolicies}
        timeRange={renewalTimeRange}
        onTimeRangeChange={setRenewalTimeRange}
      />
    </div>
  );
}
